const math = {
    fixedNum : 2,
    // 加法
    plus () {
        let _num = 0;
        if (typeof arguments[0] === 'object' && arguments[0]) {
            arguments[0].forEach(val => {
                    _num = Number(_num) + Number(val);
                    }); 
        } else {
            Object.values(arguments).forEach(val => {
                    _num = Number(_num) + Number(val);
                    }); 
        }   
        let _pos = String(_num).indexOf('.');
        if (Number(_pos) > -1) {
            let _count = String(_num).length - (Number(_pos) + 1); 
            if (_count > math.fixedNum) {
                _num = _num.toFixed(math.fixedNum);
            }   
        }   
        return Number(_num);
    },
    // 减法
    minus () {
        let _num = 0;
        if (typeof arguments[0] === 'object' && arguments[0]) {
            arguments[0].forEach((val, key) => {
                    if (key === 0) {
                    _num = Number(val);
                    } else {
                    _num = Number(_num) - Number(val);
                    }   
                    }); 
        } else {
            Object.values(arguments).forEach((val, key) => {
                    if (key === 0) {
                    _num = Number(val);
                    } else {
                    _num = Number(_num) - Number(val);
                    }   
                    }); 
        }   
        let _pos = String(_num).indexOf('.');
        if (Number(_pos) > -1) {
            let _count = String(_num).length - (Number(_pos) + 1);
            if (_count > math.fixedNum) {
                _num = _num.toFixed(math.fixedNum);
            }
        }
        return Number(_num);
    },
    // 乘法
    multiple () {
        let _num = 0;
        if (typeof arguments[0] === 'object' && arguments[0]) {
            arguments[0].forEach((val, key) => {
                    if (key === 0) {
                    _num = Number(val);
                    } else {
                    _num = Number(_num) * Number(val);
                    }
                    });
        } else {
            Object.values(arguments).forEach((val, key) => {
                    if (key === 0) {
                    _num = Number(val);
                    } else {
                    _num = Number(_num) * Number(val);
                    }
                    });
        }
        let _pos = String(_num).indexOf('.');
        if (Number(_pos) > -1) {
            let _count = String(_num).length - (Number(_pos) + 1);
            if (_count > math.fixedNum) {
                _num = _num.toFixed(math.fixedNum);
            }
        }
        return Number(_num);
    },
    // 除法
    division () {
        let _num = 0;
        if (typeof arguments[0] === 'object' && arguments[0]) {
            arguments[0].forEach((val, key) => {
                    if (key === 0) {
                    _num = Number(val);
                    } else {
                    _num = Number(_num) / Number(val);
                    }
                    });
        } else {
            Object.values(arguments).forEach((val, key) => {
                    if (key === 0) {
                    _num = Number(val);
                    } else {
                    _num = Number(_num) / Number(val);
                    }
                    });
        }
        let _pos = String(_num).indexOf('.');
        if (Number(_pos) > -1) {
            let _count = String(_num).length - (Number(_pos) + 1);
            if (_count > math.fixedNum) {
                _num = _num.toFixed(math.fixedNum);
            }
        }
        return Number(_num);
    },
    setFixedNum (val) {
        math.fixedNum = Number(val);
    }
}

Math.plus       = math.plus;
Math.minus      = math.minus;
Math.multiple   = math.multiple;
Math.division   = math.division;
Math.setFixedNum   = math.setFixedNum;

export default Math;



// WEBPACK FOOTER //
// ./src/utils/math.js